export default __webpack_public_path__ + "static/0318-6e86bcac2a837bcb4575d52834c9cb65.png";